import React, { useContext, useState, useEffect, useMemo } from 'react';
import { Button, Modal, Form, Input, Rate, Select, message, Checkbox, Card, Typography, Space, Tag, Descriptions, Tabs, List, Avatar, DatePicker } from 'antd';
import { User, CheckCircle, XCircle, Shield, Plus, Phone, Mail, MessageCircle, MapPin, Calendar, CreditCard, List as ListIcon } from 'react-feather';
import { ModalContext } from 'context/ModalContext';
import { useParams } from 'react-router-dom';
import {
  list_my_products,
  sendClientHelpQuotation,
  acceptOrRejectQuotation,
  addRecommendation,
  fetchGuestQuotationDetails,
  list_undewriter_products,
} from 'services/apiSrv';
import { useQuery, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

function ViewClientHelpRequest() {
  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
  const { id } = useParams();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);
  const [isSendLoading, setIsSendLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [availableBenefits, setAvailableBenefits] = useState([]);
  const [clientData, setClientData] = useState({
    client_names: '',
    client_fname: '',
    client_lname: '',
    client_email: '',
    kra_pin: '',
    city: '',
    registration_date: '',
    avatar: '',
    risks: {},
  });

    const { data: quotationData, isLoading: isQuotationLoading, error: quotationError } = useQuery({
    queryKey: ['fetch_guest_quotation_details', id],
    queryFn: async () => {
      const resp = await fetchGuestQuotationDetails(id);
      return resp.data;
    },
    enabled: !!id,
    onSuccess: (data) => {
      const item = data[0];
      if (item) {
        setClientData({
          client_names: [item?.clientDetails?.names?.firstName, item?.clientDetails?.names?.lastName].filter(Boolean).join(" ") || 'N/A',
          client_fname: item?.clientDetails?.names?.firstName || 'N/A',
          client_lname: item?.clientDetails?.names?.lastName || 'N/A',
          client_email: item?.clientDetails?.email || 'N/A',
          kra_pin: item?.clientDetails?.kraPin || 'N/A',
          city: item?.clientDetails?.kyc?.city || 'N/A',
          registration_date: item?.createdAt ? new Date(item.createdAt).toLocaleString() : 'N/A',
          avatar: item?.clientDetails?.avatar ?? '',
          risks: item.riskDetails,
        });
      }
    },
    onError: () => {
      message.error("Failed to load quotation details.");
    }
  });

  // console.log("QD", quotationData[0].insuranceClassSystemRef)

  
  const { data: productList, isLoading: isProductLoading } = useQuery({
    queryKey: ['products'],
    queryFn: list_my_products,
  });

    const insuranceClassRef = "07" ?? quotationData?.[0]?.insuranceClassSystemRef;

    const { data: underwriterProductList, isLoading: isProductUnderwriterLoading } = useQuery({
      queryKey: ['underwriter_products', insuranceClassRef],
      queryFn: () => list_undewriter_products(insuranceClassRef),
      enabled: !!insuranceClassRef, // Only run when we have the ref
    });


  
  //   const { data: underwriterProductList, isLoading: isProductUnderwriterLoading } = useQuery({
  //   queryKey: ['products'],
  //   queryFn: () => list_undewriter_products(quotationData[0].insuranceClassSystemRef),
  // });

   console.log("upl", underwriterProductList)
  

  const combinedProductList = useMemo(() => {
    const myProducts = productList?.data?._value || [];
    const underwriterProducts = underwriterProductList?.data || [];
  
    const allProducts = [
      ...myProducts.map(p => ({ ...p, source: 'mine' })),
      ...underwriterProducts.map(p => ({ ...p, source: 'underwriter' }))
    ];
    return allProducts
  })


  //product.productCover.supportedPeriods

  useEffect(() => {
    if (selectedProduct?.productBenefits) {
      const benefits = selectedProduct.productBenefits.filter((benefit) => {
        return (benefit.benefitType || '').toLowerCase() === 'optional';
      });
      setAvailableBenefits(benefits);
    } else {
      setAvailableBenefits([]);
    }
  }, [selectedProduct]);

console.log("SP", selectedProduct)

  console.log("BENEFITS", availableBenefits)

  const handleSend = async () => {
    setIsSendLoading(true);
    try {
      await sendClientHelpQuotation(id);
      message.success('Quotation sent successfully!');
      await queryClient.invalidateQueries(['fetch_guest_quotation_details', id]);
    } catch (error) {
      message.error('Failed to send quotation. Please try again.');
    } finally {
      setIsSendLoading(false);
    }
  };

  const handleAcceptOrReject = async (quotationRequestRef, status) => {
    try {
      await acceptOrRejectQuotation(quotationRequestRef, status);
      message.success(`Quotation ${status} successfully!`);
      await queryClient.invalidateQueries(['fetch_guest_quotation_details', id]);
    } catch (error) {
      message.error(`Failed to ${status} quotation. Please try again.`);
    }
  };

  const handleAddRecommendation = async (values) => {
    try {
      const quotationRequestRef = quotationData?.[0]?.quotationRequestRef || id;
      const selectedBenefits = availableBenefits.filter((benefit) =>
        values.additionalBenefits.includes(
          benefit.benefitSystemRef || benefit.benefitRef || benefit.id
        )
      );
      const benefitValues = selectedBenefits.map((benefit) => ({
        benefitSystemRef: benefit.benefitSystemRef,
        benefitInternaleRef: benefit.benefitInternaleRef,
        params: { limit: 0 },
      }));
      const formattedValues = {
        ...values,
        productSystemRef: values.productSystemRef,
        additionalBenefits: benefitValues || [],
        cover: parseFloat(values.cover),
        coverStartDate: values.coverStartDate.format('YYYY-MM-DD'),
      };

      await addRecommendation(formattedValues, quotationRequestRef);
      message.success('Recommendation added successfully!');
      await queryClient.invalidateQueries(['fetch_guest_quotation_details', id]);
      modalClose();
    } catch (error) {
      setError(error.message || 'Failed to add recommendation');
      message.error('Failed to add recommendation. Please try again.');
    }
  };

  const validationSchema = Yup.object({
    productSystemRef: Yup.string().required('Product is required'),
    remarks: Yup.string().required('Remarks are required'),
    recommendationLevel: Yup.number()
      .min(1, 'Recommendation level must be at least 1')
      .max(5, 'Recommendation level must be at most 5')
      .required('Recommendation level is required'),
    additionalBenefits: Yup.array().optional(),
    cover: Yup.number()
      .typeError('Cover amount must be a number')
      .positive('Cover amount must be positive')
      .required('Cover amount is required'),
    coverStartDate: Yup.date()
      .min(moment().startOf('day'), 'Cover start date cannot be in the past')
      .required('Cover start date is required'),
  });

  const recommendations = quotationData?.[0]?.reccommendations || [];
  const risks = quotationData?.[0]?.riskDetails || [];
  const quotationStatus = quotationData?.[0]?.status;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'accepted':
        return 'success';
      case 'rejected':
      case 'overdue':
        return 'error';
      case 'pending':
        return 'warning';
      default:
        return 'default';
    }
  };

  if (isQuotationLoading) {
    return <div>Loading quotation data...</div>;
  }

  if (quotationError) {
    return <div>Error: {quotationError.message}</div>;
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', padding: '24px' }}>
      <Card
        style={{ marginBottom: '24px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={4} style={{ margin: 0 }}>Quotation Details</Title>
            <Space>
              <Button
                type="primary"
                onClick={() => setModalShow('recommendation')}
                disabled={quotationStatus === 'REJECTED'}
              >
                Add Recommendation
              </Button>
              <Button
                onClick={handleSend}
                loading={isSendLoading}
                disabled={isQuotationLoading || quotationStatus !== 'ACCEPTED'}
              >
                Send Quotation
              </Button>
              <Button
                type=""
                icon={<CheckCircle size={16} />}
                onClick={() => handleAcceptOrReject(quotationData[0]?.quotationRequestRef || id, 'ACCEPTED')}
                disabled={ quotationStatus === 'ACCEPTED' || quotationStatus === 'REJECTED'}
              >
                Accept
              </Button>
              <Button
                type="default"
                danger
                icon={<XCircle size={16} />}
                onClick={() => handleAcceptOrReject(quotationData[0]?.quotationRequestRef || id, 'REJECTED')}
                disabled={ quotationStatus === 'REJECTED' || quotationStatus === 'ACCEPTED'}
              >
                Reject
              </Button>
            </Space>
          </div>
        }
      >
        <Descriptions bordered column={1} size="middle" labelStyle={{ width: '20%', fontWeight: 500, background: '#fafafa' }} contentStyle={{ background: '#fff' }}>
          <Descriptions.Item label="Request ID">{id}</Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={getStatusColor(quotationStatus)}>{quotationStatus?.toUpperCase() || 'PENDING'}</Tag>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Tabs
        type="card"
        size="large"
        style={{
          '& .ant-tabs-card .ant-tabs-content': {
            marginTop: '16px'
          }
        }}
        items={[
          {
            key: '1',
            label: (
              <Space>
                <User size={16} />
                Client Details
              </Space>
            ),
            children: (
              <Card
                style={{
                  borderRadius: '16px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
                  border: 'none',
                  background: 'white',
                }}
              >
                <div style={{
                  display: 'flex',
                  gap: '24px',
                  flexWrap: 'wrap',
                }}>
                  {/* Client Profile Card */}
                  <Card
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
                      border: 'none',
                      background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                      color: 'white',
                      minWidth: '320px',
                      flex: '0 0 auto'
                    }}
                  >
                    <div style={{ textAlign: 'center', padding: '8px 0' }}>
                      {/* Enhanced Avatar Section */}
                      <div style={{
                        position: 'relative',
                        display: 'inline-block',
                        marginBottom: '20px'
                      }}>
                        <div style={{
                          width: '140px',
                          height: '140px',
                          borderRadius: '50%',
                          overflow: 'hidden',
                          margin: '0 auto',
                          border: '5px solid rgba(255,255,255,0.3)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                          position: 'relative'
                        }}>
                          <Avatar
                            size={140}
                            src={clientData.avatar}
                            style={{ objectFit: 'cover' }}
                            icon={<User />}
                          />
                        </div>
                        {/* Status indicator */}
                        <div style={{
                          position: 'absolute',
                          bottom: '10px',
                          right: '10px',
                          width: '24px',
                          height: '24px',
                          backgroundColor: getStatusColor(quotationStatus),
                          border: '3px solid white',
                          borderRadius: '50%',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                        }} />
                      </div>
                      <Title level={3} style={{
                        margin: '0 0 8px 0',
                        color: 'white',
                        fontWeight: 600,
                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        {clientData.client_names || 'Client Name'}
                      </Title>
                      <div style={{
                        display: 'flex',
                        gap: '8px',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        marginBottom: '20px'
                      }}>
                        <div style={{
                          background: 'rgba(255,255,255,0.2)',
                          backdropFilter: 'blur(10px)',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: 500
                        }}>
                          <MapPin size={12} style={{ marginRight: '4px' }} />
                          {clientData.city || 'City'}
                        </div>
                        <div style={{
                          background: 'rgba(255,255,255,0.2)',
                          backdropFilter: 'blur(10px)',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: 500
                        }}>
                          <Calendar size={12} style={{ marginRight: '4px' }} />
                          {clientData.registration_date || 'Date'}
                        </div>
                      </div>
                      <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'center'
                      }}>
                        <Button
                          type="text"
                          shape="circle"
                          icon={<Phone size={18} />}
                          style={{
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            border: 'none',
                            color: 'white',
                            width: '44px',
                            height: '44px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        />
                        <Button
                          type="text"
                          shape="circle"
                          icon={<Mail size={18} />}
                          style={{
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            border: 'none',
                            color: 'white',
                            width: '44px',
                            height: '44px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        />
                        <Button
                          type="text"
                          shape="circle"
                          icon={<MessageCircle size={18} />}
                          style={{
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            border: 'none',
                            color: 'white',
                            width: '44px',
                            height: '44px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                  {/* Client Information Card */}
                  <Card
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
                      border: 'none',
                      flex: '1 1 400px',
                      minWidth: '400px'
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '28px'
                    }}>
                      <Title level={3} style={{
                        margin: 0,
                        color: '#1f2937',
                        fontWeight: 600
                      }}>
                        Client Information
                      </Title>
                    </div>
                    <div style={{ display: 'grid', gap: '24px' }}>
                      <div>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '16px',
                          paddingBottom: '8px',
                          borderBottom: '2px solid #e5e7eb'
                        }}>
                          <User size={18} color="#6366f1" />
                          <Text strong style={{ fontSize: '16px', color: '#374151' }}>
                            Personal Information
                          </Text>
                        </div>
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                          gap: '20px'
                        }}>
                          <div style={{
                            padding: '16px',
                            backgroundColor: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                          }}>
                            <Text type="secondary" style={{
                              fontSize: '12px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              fontWeight: 600
                            }}>
                              First Name
                            </Text>
                            <div style={{
                              fontSize: '15px',
                              fontWeight: 500,
                              color: '#1f2937',
                              marginTop: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <User size={14} color="#3b82f6" />
                              {clientData.client_fname || 'Not specified'}
                            </div>
                          </div>
                          <div style={{
                            padding: '16px',
                            backgroundColor: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                          }}>
                            <Text type="secondary" style={{
                              fontSize: '12px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              fontWeight: 600
                            }}>
                              Last Name
                            </Text>
                            <div style={{
                              fontSize: '15px',
                              fontWeight: 500,
                              color: '#1f2937',
                              marginTop: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <User size={14} color="#3b82f6" />
                              {clientData.client_lname || 'Not specified'}
                            </div>
                          </div>
                          <div style={{
                            padding: '16px',
                            backgroundColor: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                          }}>
                            <Text type="secondary" style={{
                              fontSize: '12px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              fontWeight: 600
                            }}>
                              Email
                            </Text>
                            <div style={{
                              fontSize: '15px',
                              fontWeight: 500,
                              color: '#1f2937',
                              marginTop: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <Mail size={14} color="#10b981" />
                              {clientData.client_email || 'Not specified'}
                            </div>
                          </div>
                          <div style={{
                            padding: '16px',
                            backgroundColor: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                          }}>
                            <Text type="secondary" style={{
                              fontSize: '12px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              fontWeight: 600
                            }}>
                              KRA PIN
                            </Text>
                            <div style={{
                              fontSize: '15px',
                              fontWeight: 500,
                              color: '#1f2937',
                              marginTop: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <CreditCard size={14} color="#f59e0b" />
                              {clientData.kra_pin || 'Not specified'}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </Card>
            )
          },
          {
            key: '2',
            label: (
              <Space>
                <Shield size={16} />
                Risk Details
              </Space>
            ),
            children: (
              <div>
                <Card
                  style={{
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                    border: 'none',
                    minHeight: '300px'
                  }}
                >
                  <Title level={4} style={{ margin: '0 0 16px' }}>Risk Details</Title>
                  <div style={{
                            padding: '16px',
                            backgroundColor: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                          }}>
                            <Text type="secondary" style={{
                              fontSize: '12px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              fontWeight: 600
                            }}>
                              Registration Number
                            </Text>
                            <div style={{
                              fontSize: '15px',
                              fontWeight: 500,
                              color: '#1f2937',
                              marginTop: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <User size={14} color="#3b82f6" />
                              {risks.regNo || 'Not specified'}
                            </div>
                          </div>
                          <div style={{
                            padding: '16px',
                            backgroundColor: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                          }}>
                            <Text type="secondary" style={{
                              fontSize: '12px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              fontWeight: 600
                            }}>
                              Vehicle Value
                            </Text>
                            <div style={{
                              fontSize: '15px',
                              fontWeight: 500,
                              color: '#1f2937',
                              marginTop: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <Mail size={14} color="#10b981" />
                              {risks.value.toLocaleString()|| 'Not specified'}
                            </div>
                          </div>
                          <div style={{
                            padding: '16px',
                            backgroundColor: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                          }}>
                            <Text type="secondary" style={{
                              fontSize: '12px',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              fontWeight: 600
                            }}>
                              Chassis Number
                            </Text>
                            <div style={{
                              fontSize: '15px',
                              fontWeight: 500,
                              color: '#1f2937',
                              marginTop: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <CreditCard size={14} color="#f59e0b" />
                              {risks.chassisNumber || 'Not specified'}
                            </div>
                          </div>
                </Card>
              </div>
            )
          },
          {
            key: '3',
            label: (
              <Space>
                <ListIcon size={16} />
                Recommendations
              </Space>
            ),
            children: (
              <Card
                style={{
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  border: 'none',
                  minHeight: '300px'
                }}
              >
                <Title level={4} style={{ margin: '0 0 16px' }}>Recommendations</Title>
                <List
                  itemLayout="horizontal"
                  dataSource={recommendations}
                  renderItem={(item) => (
                    <List.Item style={{ padding: '16px', borderRadius: '8px', border: '1px solid #e5e7eb', marginBottom: '16px' }}>
                      <List.Item.Meta
                        avatar={<Avatar style={{ backgroundColor: '#1890ff' }} icon={<CheckCircle size={16} />} />}
                        title={<Text strong>{item.product.productName || 'Recommended Product'}</Text>}
                        description={
                          <Space direction="vertical" size={8}>
                            <Text type="secondary" style={{ display: 'block' }}>
                              <Text strong>Remarks:</Text> <span style={{fontWeight:"bold", color:"#003478"}}>{item.remarks}</span>
                            </Text>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Text strong style={{ marginRight: '8px' }}>Recommendation Level:</Text>
                              <Rate
                                disabled
                                allowHalf
                                defaultValue={item.reccommendationLevel || 0}
                                style={{ fontSize: '14px',fontWeight:"bold", color:"#003478" }}
                              />
                            </div>
                            <Text type="secondary" style={{ display: 'block' }}>
                              <Text strong>Premium Amount:</Text> <span style={{fontWeight:"bold", color:"#003478"}}>{item?.premiumAmount.toLocaleString()}</span>
                            </Text>
                          </Space>
                        }
                      />
                    </List.Item>
                  )}
                />
                {recommendations.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '40px', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
                    <ListIcon size={48} color="#94a3b8" style={{ marginBottom: '16px' }} />
                    <Title level={4} style={{ color: '#595959' }}>No Recommendations Added</Title>
                    <Text type="secondary">Click "Add Recommendation" to get started.</Text>
                  </div>
                )}
              </Card>
            )
          }
        ]}
      />

      <Modal
        title="Add Recommendation"
        open={modalShow === 'recommendation'}
        onCancel={modalClose}
        footer={null}
      >
        <Formik
          initialValues={{
            productSystemRef: '',
            remarks: '',
            recommendationLevel: 3,
            additionalBenefits: [],
            cover: '',
            coverStartDate: null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleAddRecommendation}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <Form layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                label="Select Product"
                validateStatus={touched.productSystemRef && errors.productSystemRef ? 'error' : ''}
                help={touched.productSystemRef && errors.productSystemRef}
              >
                <Select
                  showSearch
                  placeholder="Select a product"
                  value={values.productSystemRef}
                  onChange={(value) => {
                    setFieldValue('productSystemRef', value);
                    setFieldValue('additionalBenefits', []);
                    const product = combinedProductList?.find((p) => p.productSystemRef === value);
                    setSelectedProduct(product || null);
                  }}
                  loading={isProductLoading}
                  notFoundContent={isProductLoading ? 'Loading...' : 'No products available'}
                >
                  {combinedProductList?.map((product) => (
                    <Select.Option key={product.productSystemRef} value={product.productSystemRef}>
                      {product.productName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

                  <Form.Item
                    label="Cover Period"
                    validateStatus={touched.cover && errors.cover ? 'error' : ''}
                    help={touched.cover && errors.cover}
                    required
                  >
                    <Select
                      placeholder={
                        selectedProduct
                          ? selectedProduct.productCover?.supportedPeriods?.length
                            ? "Choose cover period"
                            : "No cover periods defined for this product"
                          : "First select a product"
                      }
                      value={values.cover}
                      onChange={(val) => setFieldValue('cover', val)}
                      disabled={!selectedProduct || !selectedProduct.productCover?.supportedPeriods?.length}
                      allowClear
                      showSearch={false}
                    >
                      {selectedProduct?.productCover?.supportedPeriods?.map((period) => (
                        <Select.Option key={period} value={period}>
                          {typeof period === 'number' ? period.toLocaleString() : period} Day(s)
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
             
          

              <Form.Item
                label="Cover Start Date"
                validateStatus={touched.coverStartDate && errors.coverStartDate ? 'error' : ''}
                help={touched.coverStartDate && errors.coverStartDate}
              >
                <DatePicker
                  value={values.coverStartDate}
                  onChange={(date) => setFieldValue('coverStartDate', date)}
                  disabledDate={(current) => current && current < moment().startOf('day')}
                  placeholder="Select cover start date"
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item
                label="Additional Benefits"
                validateStatus={touched.additionalBenefits && errors.additionalBenefits ? 'error' : ''}
                help={touched.additionalBenefits && errors.additionalBenefits}
              >
                {availableBenefits.length > 0 ? (
                  <Checkbox.Group
                    options={availableBenefits.map((benefit) => ({
                      label: benefit.benefit_category_name || 'Unnamed Benefit',
                      value: benefit.benefitSystemRef || benefit.benefitRef || benefit.id,
                    }))}
                    value={values.additionalBenefits}
                    onChange={(checkedValues) => setFieldValue('additionalBenefits', checkedValues)}
                  />
                ) : (
                  <Text type="secondary">No optional benefits available for this product.</Text>
                )}
              </Form.Item>

              <Form.Item
                label="Remarks"
                validateStatus={touched.remarks && errors.remarks ? 'error' : ''}
                help={touched.remarks && errors.remarks}
              >
                <Input.TextArea
                  name="remarks"
                  value={values.remarks}
                  onChange={handleChange}
                  placeholder="Enter recommendation remarks"
                />
              </Form.Item>

              <Form.Item
                label="Recommendation Level"
                validateStatus={touched.recommendationLevel && errors.recommendationLevel ? 'error' : ''}
                help={touched.recommendationLevel && errors.recommendationLevel}
              >
                <Rate
                  value={values.recommendationLevel}
                  onChange={(value) => setFieldValue('recommendationLevel', value)}
                  count={5}
                />
              </Form.Item>

              {error && (
                <Form.Item>
                  <Text type="danger">{error}</Text>
                </Form.Item>
              )}

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={isSubmitting || isProductLoading}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Recommendation'}
                </Button>
              </Form.Item>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}

export default ViewClientHelpRequest;